import {Constants} from '@/utils/constants/commonConstants'

export const uploadFileDescriptionForCSV = () => {
  return (
    <div>
      <span>{Constants.DragAndDrop}</span>
      <br />
      <span>{Constants.OnlyCsv}</span>
    </div>
  )
}

export const uploadFileCSVError = () => {
  return (
    <div>
      <span>{Constants.UploadError}:</span>
      <br />
      <span>
        Your CSV file couldn’t be processed due to some formatting issues. Please check the following common errors and
        try again:
      </span>
      <br />
      <span>Missing Fields: Ensure all required columns (e.g., Name, Email, ID) are filled in.</span>
      <br />
      <span>Arrow Symbols: Remove any “→” symbols or special characters that might have been added.</span>
    </div>
  )
}

export const uploadImageCSVError = () => {
  return (
    <div>
      <span>{Constants.CorruptedFile}:</span>
      <br />
      <span>Make sure the image file is not corrupted or incomplete.</span>
    </div>
  )
}
